inherit("Protection", {
	parent: `Class`,
	singleton: true,
	requires: [`XHR`],
	constructor(setup) {
		const { XHR } = this;
		const onReady = () => {
			// DataDome api is ready, keep track and remove the listener
			isReady = true;
			window.removeEventListener(`dd_ready`, onReady);
		};
		let isReady = false;

		window.addEventListener(`dd_ready`, onReady);

		XHR.addErrorHandler({
			priority: `high`,
			order: 10,
			handler: async (reason) => {
				if (reason.status === 403) {
					const challengeId = reason.getResponseHeader(`X-Datadome-Cid`);

					if (this.isString(challengeId, 1)) {
						if (!isReady) {
							await this.defer({ duration: 2000 });

							if (!isReady) {
								const type = `warning`;
								const message = `DataDome api timed out.`;
								this.log({ message, type });

								// Re-throw the original error for consumers to handle
								throw reason;
							}
						}

						return this.getChallengePromise();
					}
				}

				// Re-throw the original error for consumers to handle
				throw reason;
			},
		});

		// initialize the third party library
		const { Config } = this;
		const { DATADOME_JS_API_KEY } = Config;

		window.ddjskey = DATADOME_JS_API_KEY;
		window.ddoptions = {
			abortAsyncOnCaptchaDisplay: false,
			ajaxListenerPath: true,
			allowHtmlContentTypeOnCaptcha: true,
			disableAutoRefreshOnCaptchaPassed: true,
			enableTagEvents: true,
		};
		const deps = [`https://js.datadome.co/tags.js`];
		this.require({ deps });
	},
	api: {
		getChallengePromise: {
			async: true,
			value(options) {
				return new Promise((resolve) => {
					// success handler
					const onChallengePassed = () => {
						// remove the relevant DataDome listeners
						window.removeEventListener(`dd_response_passed`, onChallengePassed);

						// resolve the promise, so the XHR controller retries the request
						resolve();
					};

					// add the relevant DataDome listeners
					window.addEventListener(`dd_response_passed`, onChallengePassed);
				});

				// DataDome events: dd_ready, dd_post, dd_post_done, dd_blocked, dd_response_displayed, dd_response_error, dd_response_passed
			},
		},
	},
});

//# sourceMappingURL=Protection.js.map